
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.789","height":"17.185"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 85","fill":"#044370"}},[_c('path',{attrs:{"data-name":"Tracé 6761","d":"M20.648 8.742c-.182-.246-4.619-5.991-10.254-5.991a8.607 8.607 0 00-1.594.152.693.693 0 10.256 1.362 7.238 7.238 0 011.337-.128c4.123 0 7.7 3.749 8.8 5.024a19.251 19.251 0 01-2.325 2.27.693.693 0 00.88 1.071 19.456 19.456 0 002.893-2.921.693.693 0 00.007-.839z"}}),_c('path',{attrs:{"data-name":"Tracé 6762","d":"M16.077 12.726l-3.049-3.049-3.15-3.15-2.709-2.709L3.551.2a.7.7 0 00-.977.991l2.942 2.942A19.1 19.1 0 00.142 8.738a.693.693 0 000 .839c.184.246 4.619 5.991 10.253 5.991a10.246 10.246 0 005.083-1.487l2.886 2.9a.694.694 0 00.981-.981zM9.292 7.899l2.367 2.367a1.677 1.677 0 11-2.367-2.367zm1.1 6.286c-4.123 0-7.7-3.749-8.8-5.024a17.45 17.45 0 014.946-4.016l1.778 1.774a3.06 3.06 0 104.321 4.319l1.826 1.826a8.663 8.663 0 01-4.065 1.121z"}})])])
          )
        }
      }
    